import React, { useMemo } from 'react';

import { groupBy } from 'lodash';
import { useTranslation } from 'react-i18next';

import ListObjectFilter from 'common-ui/lists/listObjectFilter';
import { PortfolioListing } from 'core/lib';
import { OBJECT_TYPES } from 'core/lib/constants';

type PortfolioByComplianceStatusProps = {
  data?: PortfolioListing[];
};

const PortfoliosByComplianceStatus = ({ data }: PortfolioByComplianceStatusProps) => {
  const { t } = useTranslation();

  const dataByComplianceStatus = useMemo(
    () => groupBy(data, (d) => d.complianceStatus?.name ?? t('global:results.notSpecified')),
    [data, t]
  );

  return (
    <ListObjectFilter<PortfolioListing>
      placeholder={t('portfolio:placeholders.searchComplianceStatus')}
      data={dataByComplianceStatus}
      title={t('portfolio:dashboards.titles.complianceStatus')}
      objectType={OBJECT_TYPES.PORTFOLIO}
    />
  );
};

export default PortfoliosByComplianceStatus;
